import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Requirement } from '../../classess/requirement/requirement';
import {
    getProcessButtons, setDateTimeFormatGlobalString, isUndNullEmp, isValidDate, getLanguageObj, getResponse, getRolesType, settings, styles,
    handleResponseMessageAsync, LoadingSection
} from '../../helpers/main';
import { User } from '../../classess/user/user';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { RequirementDetail } from '../../classess/requirement/requirementDetail';
import { RequirementService } from '../../services/requirements/RequirementService';

const { html, icons, images, labels, messages, } = settings;

const currentMethod = 'RequirementDetailAddEditDetail';

export default function RequirementDetailAddEditDetail({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtRequirementDetailsId: '',
        dtRequirementDetailsRowId: 0,
        requirement: Requirement.getClass({}, false),
        requirementDetail: RequirementDetail.getClass({}, false),
        rdFieldViews: {
            commentary: '',
            registerDate: {
                date: '',
                time: ''
            },
            requirement: {
                id: 0,
            },
            users: {
                analyst: {
                    name: '',
                },
            },
        },
        analysts: [User?.getClass({}, false)],
        userRoles: getRolesType(),
    },
    setModalObj = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [dataFormLength] = useState(Requirement.minMaxLength(false));
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: false, save: false });

    const [errors, setErrors] = useState({
        analyst: '',
        registerDate: '',
        commentary: '',
    });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        checkBoxs: {
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            registerDate: {
                id: 'inputModalUserRegisterDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
            requirement: {
                id: 'inputModalRequirement',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
        pickers: {
            registerDate: {
                id: 'pkModalRegisterDate',
            },
        },
        selects: {
            analysts: {
                id: 'selModalAnalyst',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
        textAreas: {
            commentary: {
                id: 'txtAreaModalCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            }
        }
    };
    //#endregion variables

    //#region methods
    //#region requirementdetail
    const AddRequirementDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'AddRequirementDetail';
        try {
            if (e) e?.preventDefault?.();

            setProcess(prev => ({ ...prev, save: true }));

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const requerimentDetailSetData = response?.result?.requirementDetail || modalObj?.requirementDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            //#region requirementdetail (create)
            response = await RequirementService.createDetail({
                auth: modalObj?.auth,
                data: requerimentDetailSetData,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const newRequirementDetail = response?.result?.requirementDetail || {};
            //#endregion requirementdetail (create)

            //#region datatable add
            const modelRequirementDetail = RequirementDetail.getClass(newRequirementDetail, false);
            const modelAnalyst = User?.getClass(modalObj?.analysts?.filter(({ id }) => id === modelRequirementDetail?.analystId)[0] || {}, false);
            const dateTime = modelRequirementDetail?.registerDate;
            const date = setDateTimeFormatGlobalString({
                date: modelRequirementDetail?.registerDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            const time = setDateTimeFormatGlobalString({
                date: modelRequirementDetail?.registerDate,
                dateFormat: '',
                timeFormat: modalObj?.languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            const analystFullName = `${modelAnalyst?.firstName || ''} - ${modelAnalyst?.lastName || ''}`;
            const buttonDescription = `${date} ${time} - ${analystFullName}`;

            modalObj?.$(`#${modalObj?.dtRequirementDetailsId}`).DataTable().row.add([
                dateTime,
                date,
                time,
                analystFullName,
                modelRequirementDetail?.commentary || '',
                getProcessButtons({
                    id: modelRequirementDetail.id,
                    description: buttonDescription,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const editRequirementDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editRequirementDetail';
        try {
            if (e) e?.preventDefault?.();

            setProcess(prev => ({ ...prev, save: true }));

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const requerimentDetailSetData = response?.result?.requirementDetail || modalObj?.requirementDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            //#region requirementdetail (update)
            response = await RequirementService.updateDetail({
                auth: modalObj?.auth,
                id: modalObj?.requirementDetail?.id || 0,
                data: requerimentDetailSetData || {},
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const updatedRequirementDetail = response?.result?.requirementDetail || {};
            //#endregion requirementdetail (update)

            //#region datatable update
            const modelRequirementDetail = RequirementDetail.getClass(updatedRequirementDetail, false);
            const modelAnalyst = User?.getClass(modalObj?.analysts?.filter(({ id }) => id === modelRequirementDetail?.analystId)[0] || {}, false);
            const dateTime = modelRequirementDetail?.registerDate;
            const date = setDateTimeFormatGlobalString({
                date: modelRequirementDetail?.registerDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            const time = setDateTimeFormatGlobalString({
                date: modelRequirementDetail?.registerDate,
                dateFormat: '',
                timeFormat: modalObj?.languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            const analystFullName = `${modelAnalyst?.firstName || ''} - ${modelAnalyst?.lastName || ''}`;
            const buttonDescription = `${date} ${time} - ${analystFullName}`;

            modalObj?.$(`#${modalObj?.dtRequirementDetailsId}`).DataTable().row(modalObj?.dtRequirementDetailsRowId).data([
                dateTime,
                date,
                time,
                analystFullName,
                modelRequirementDetail?.commentary || '',
                getProcessButtons({
                    id: modelRequirementDetail.id,
                    description: buttonDescription,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable update

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }
    //#endregion requirementdetail

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (modalObj?.type !== 2) {
                //#region set data input timers
                response = setDateInControl({
                    _date: new Date().toISOString(),
                    _registerDate: modalObj?.requirementDetail?.registerDate,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set data input timers
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            //#region variables
            const registerDate = modalObj?.$(`#${controls?.inputs?.registerDate?.id}`).val();
            const requiredMsg = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;
            //#endregion variables

            //#region method
            if (isUndNullEmp({ data: modalObj?.requirementDetail?.analystId, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, analyst: requiredMsg }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: registerDate, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, registerDate: requiredMsg }));
                response.isWarning = true;
            } else if (!isValidDate({ data: registerDate, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, registerDate: requiredMsg }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirementDetail?.commentary, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, commentary: requiredMsg }));
                response.isWarning = true;
            }
            //#endregion method
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({
                ...prev,
                analyst: '',
                registerDate: '',
                commentary: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setData';
        try {
            //#region variables
            const registerDate = modalObj?.$(`#${controls?.pickers?.registerDate?.id}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            const requirementDetailSetData = {
                ...modalObj?.requirementDetail,
                registerDate: moment(registerDate).format(`${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}.000Z`)
            };

            setModalObj(prev => ({
                ...prev,
                requirementDetail: requirementDetailSetData
            }));

            response.result = { requirementDetail: requirementDetailSetData };
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        _date = undefined,
        _registerDate = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDateInControl';
        try {
            //#region variables
            let registerDate = '';
            const tf = modalObj?.languageObj?.format?.time?.type;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;
            const df = modalObj?.languageObj?.format?.date?.f1;
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: _registerDate, subMethod: currentMethod })?.result) {
                registerDate = setDateTimeFormatGlobalString({ date: _registerDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                registerDate = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj?.$.extend({}, modalObj.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            modalObj?.$(`#${controls?.pickers?.registerDate?.id}`)?.datetimepicker(
                'options',
                {
                    date: registerDate,
                    default: false,
                    timepicker: true,
                    format: dtf,
                }
            );
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []);//eslint-disable-line
    //#endregion others
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='requirements' src={images?.icons?.requirements} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.requirement?.[modalObj?.languageObj?.id]} ({labels?.detail?.[modalObj?.languageObj?.id]?.toLowerCase()})</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                style={html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px', outline: 'none' }}
                    onClick={() => setDefaultValue({ closeModal: true })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className='card-body p-4'>
                        {showData ? (
                            <div className='position-relative'>
                                <LoadingSection alt='loadingSection'
                                    className='overlay dark text-white'
                                    height={20}
                                    hidden={!process?.showLoading}
                                    width={20}
                                    languageId={modalObj?.languageObj?.id}
                                    subMethod={currentMethod} />

                                {modalObj?.type !== 2 ? (
                                    <div className='row'>
                                        <div className='col-md-12 mb-3'>
                                            <div className='form-group'>
                                                <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                    <i className={icons?.fasFa?.fileContract} /> {labels?.requirement?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <input id={controls?.inputs?.requirement?.id}
                                                    disabled
                                                    className={controls?.inputs?.requirement?.defaultClass}
                                                    style={{ borderRadius: '5px' }}
                                                    placeholder={labels?.requirement?.[modalObj?.languageObj?.id]}
                                                    value={!isUndNullEmp({ data: modalObj?.requirement?.id, subMethod: controls?.inputs?.requirement?.id })?.result && modalObj?.requirement?.id > 0 ?
                                                        modalObj?.requirement?.id : 0}
                                                    title={labels?.requirement?.[modalObj?.languageObj?.id]} />
                                            </div>
                                        </div>

                                        <div className='col-md-12 mb-3' hidden={!(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst)}>
                                            <div className='form-group'>
                                                <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                    <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <select id={controls?.selects?.analysts?.id}
                                                    disabled={process?.save}
                                                    className={controls?.selects?.analysts?.defaultClass}
                                                    style={{ borderRadius: '5px' }}
                                                    value={!isUndNullEmp({ data: modalObj?.requirementDetail?.analystId, subMethod: controls?.selects?.analysts?.id, })?.result ?
                                                        modalObj?.requirementDetail?.analystId : ``
                                                    }
                                                    onChange={(e) => setModalObj(prev => ({ ...prev, requirementDetail: { ...prev?.requirementDetail, analystId: e?.target?.value }, }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, analyst: '' }))}
                                                    title={labels?.analyst?.[modalObj?.languageObj?.id]}>
                                                    <option key={`nothing`} value={``}>{messages?.selectAnalyst?.[modalObj?.languageObj?.id]}</option>
                                                    {modalObj?.analysts?.map((analyst) => <option key={analyst.id} value={analyst.id}>{analyst?.firstName}, {analyst?.lastName}</option>)}
                                                </select>
                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.analyst)}</div>
                                            </div>
                                        </div>

                                        <div className='col-md-12 mb-3' hidden={!modalObj?.userRoles?.isAdmin}>
                                            <div className='form-group'>
                                                <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                    <i className={icons?.faFa?.calendarAlt} /> {labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                </small>
                                                {!isUndNullEmp({ data: modalObj?.requirementDetail?.registerDate, subMethod: controls?.inputs?.registerDate.id, })?.result ?
                                                    <div id={controls?.pickers?.registerDate?.id} className='input-group date' data-target-input='nearest'>
                                                        <input id={controls?.inputs?.registerDate.id}
                                                            disabled={process?.save}
                                                            className={controls?.inputs?.registerDate?.defaultClass}
                                                            style={{ borderRadius: '5px' }}
                                                            data-target={`#${controls?.pickers?.registerDate?.id}`}
                                                            data-toggle='datetimepicker'
                                                            onFocus={() => setErrors(prev => ({ ...prev, registerDate: '' }))}
                                                            placeholder={labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                            title={labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                            type='text' />
                                                        <div className='input-group-append' data-target={`#${controls?.pickers?.registerDate?.id}`} data-toggle='datetimepicker'>
                                                            <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                        </div>
                                                    </div>
                                                    : <div></div>}
                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.registerDate)}</div>
                                            </div>
                                        </div>

                                        <div className='col-md-12 mb-0'>
                                            <div className='form-group'>
                                                <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                    <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <textarea id={controls?.textAreas.commentary.id}
                                                    disabled={process?.save}
                                                    className={controls?.textAreas?.commentary?.defaultClass}
                                                    style={{ minHeight: '100px', borderRadius: '5px' }}
                                                    maxLength={dataFormLength?.max?.commentary}
                                                    placeholder={labels?.commentary?.[modalObj?.languageObj?.id]}
                                                    onChange={(e) => setModalObj(prev => ({ ...prev, requirementDetail: { ...prev?.requirementDetail, commentary: e?.target?.value, } }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                                    rows={2}
                                                    value={!isUndNullEmp({ data: modalObj?.requirementDetail?.commentary, subMethod: controls?.textAreas.commentary.id })?.result ?
                                                        modalObj?.requirementDetail?.commentary : ''}
                                                    title={labels?.commentary?.[modalObj?.languageObj?.id]} />
                                                <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.commentary)}</div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='row'>
                                        <div className='col-md-12 mb-4'>
                                            <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                                <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={html?.labels?.detailMicro}>
                                                    <i className={icons?.fasFa?.fileContract} /> {labels?.requirement?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <span className='h6 mb-0 font-weight-bold'>{modalObj?.rdFieldViews?.requirement?.id || 0}</span>
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-4'>
                                            <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={html?.labels?.detailMicro}>
                                                    <i className={icons?.faFa?.calendarAlt} /> {labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <span className='h6 mb-0 font-weight-bold'>{`${modalObj?.rdFieldViews?.registerDate?.date || ''} ${modalObj?.rdFieldViews?.registerDate?.time || ''}` || '---'}</span>
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-4'>
                                            <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={html?.labels?.detailMicro}>
                                                    <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                                </small>
                                                <span className='h6 mb-0 font-weight-bold'>{modalObj?.rdFieldViews?.users?.analyst.name || '---'}</span>
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={html?.labels?.detailMicro}>
                                                <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='p-3 rounded bg-white border-left border-secondary shadow-sm' style={{ minHeight: '100px', fontSize: '0.95rem', lineHeight: '1.6', overflowWrap: 'break-word', borderLeftWidth: '5px' }}>
                                                {modalObj?.rdFieldViews?.commentary || '---'}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className='text-center py-5'>
                                <i className={`${icons?.fasFa?.lock} fa-3x text-muted mb-3`}></i>
                                <h3 className='text-muted'>{messages?.accessDenied?.[modalObj?.languageObj?.id]}</h3>
                            </div>
                        )}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button id={controls?.buttons?.save?.id}
                        className={controls?.buttons?.save?.defaultClass}
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save || modalObj?.type === 2}
                        hidden={modalObj?.type === 2}
                        onClick={(e) => modalObj?.type === 0 ?
                            AddRequirementDetail({ e: e, subMethod: 'form' }) :
                            modalObj?.type === 1 ?
                                editRequirementDetail({ e: e, subMethod: 'form' }) :
                                e.preventDefault()}
                        title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        type='button'>
                        {process?.save ? (
                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                        ) : (
                            <i id={controls?.icons?.save?.id} className={`${icons?.fasFa?.save} mr-2`} />
                        )}
                        {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.defaultClass}
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save}
                        title={labels?.close?.[modalObj?.languageObj?.id]}
                        type='button'
                        onClick={() => setDefaultValue({ closeModal: true })}>
                        <i id={controls?.icons?.back?.id} className={`${icons?.fasFa?.arrowCircleLeft} mr-2`}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}